// SiteUp: estado visual da pílula de funil (tracinhos + valor).

import { toIntlLocale } from 'shared/helpers/intlLocale';

export const FUNNEL_DASH_TOTAL = 5;

export function funnelFilledDashes(
  stageIndex,
  stageTotal,
  dashTotal = FUNNEL_DASH_TOTAL
) {
  const total = Number(stageTotal) || 0;
  if (total <= 0) return 0;
  const index = Math.max(0, Number(stageIndex) || 0);
  const ratio = Math.min(1, (index + 1) / total);
  return Math.max(1, Math.min(dashTotal, Math.round(ratio * dashTotal)));
}

export function formatOpportunityValue(raw, locale = 'pt-BR') {
  const amount = Number(raw);
  if (!Number.isFinite(amount) || amount <= 0) return '';
  return new Intl.NumberFormat(toIntlLocale(locale), {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);
}

export function stagesFromFunnel(funnel) {
  return Object.entries(funnel?.stages || {})
    .map(([key, stage]) => ({
      key,
      name: stage?.name || key,
      color: stage?.color || '#64748B',
      position: Number(stage?.position ?? 0),
    }))
    .sort((a, b) => a.position - b.position);
}
